import axios from "axios";
import user from "../Store/Modules/user"
import liveData from "../Store/Modules/liveData"
import instituteData from "../Store/Modules/instituteData";

const serverUrlForApi = process.env.VUE_APP_NBA_SERVER_V1_URL + '/nba/api/v1';
const token = JSON.parse(window.localStorage.getItem("token")) || { token: "" }
console.log('token', token);
const getHeaders = () => {
  const token = JSON.parse(window.localStorage.getItem("token")) || { token: "" }
  return {
    userType: 'faculty',
    userId: user?.state?.userData?.uId || null,
    instituteId: instituteData?.state?.selectedInstitute || null,
    instituteName: liveData?.state?.brandingName || null,
    authorization: `JWT ${token?.token}`
  }
}

export default {
  serverUrl: serverUrlForApi,
  getRequest: async (apiName, data) => {
    const res = await axios.get(serverUrlForApi + apiName, { params: data, headers: getHeaders() });
    return res.data;
  },

  postRequest: async (apiName, data, customHeaders) => {
    const config = {};
    if (customHeaders) {
      config.headers = { ...getHeaders(), ...customHeaders };
    } else config.headers = getHeaders()
    const res = await axios.post(serverUrlForApi + apiName, data, config);
    return res.data;
  },

  putRequest: async (apiName, data) => {
    const res = await axios.put(serverUrlForApi + apiName, data, { headers: getHeaders() });
    return res.data;
  },

  deleteRequest: async (apiName, data) => {
    const res = await axios.delete(serverUrlForApi + apiName, { params: data, headers: getHeaders() });
    return res;
  }
};
